const SESSION_KEY = 'pb_session_id';

const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getOrCreateSessionUuid = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

export const getSessionHash = async () => {
  const sessionUuid = getOrCreateSessionUuid();
  const enc = new TextEncoder();
  const buf = await crypto.subtle.digest('SHA-256', enc.encode(sessionUuid));
  return Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .substring(0, 32);
};

export const getSourceFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('via') === 'badge' ? 'badge' : 'shared_link';
};
